<template>
  <BaseBoxColor variant="transparent" class="w-full flex flex-col gap-4">
    <div class="flex gap-4">
      <div class="flex flex-col flex-1">
        <h6>{{ t("sessions", {count: 1}) + ' ID' }}</h6>
        <BaseSearch 
          ref="sessionSearchRef" 
          @on-searching="(newVal) => updateFilters('sessionId', newVal)" 
          style="min-width: 0 !important; width: 100% !important"
        />
      </div>
      <div class="flex flex-col flex-1">
        <h6>{{ 'Message' }}</h6>
        <BaseSearch 
          ref="messageSearchRef" 
          @on-searching="(newVal) => updateFilters('search', newVal)" 
          style="min-width: 0 !important; width: 100% !important"
        />
      </div>
    </div>
    <div class="flex gap-4" style="flex: 3">
      <div class="flex flex-col" style="flex: 1.2">
        <h6>{{ $t('channelType') }}</h6>
        <MultiSelect 
          :limit="1" 
          :options="channelTypeOptions" 
          :model-value="filters.channel"
          @update:model-value="(newVal) => updateFilters('channel', newVal)"
          :placeholder="t('select')"
        />
      </div>
      <div class="flex flex-col" style="flex: 1.8">
        <h6>{{$t("conversationDate")}}</h6>
        <DatePicker 
          ref="datePickerRef" 
          style="min-width: 0 !important;" 
          :range="true" 
          @dateChange="(newVal) => updateFilters('date', newVal)"
        />
      </div>
    </div>
    <div class="flex">
      <div class="flex flex-col flex-1 items-end">
        <BaseButton 
          variant="primary" 
          style="width: fit-content;"
          @click="handleApplyFilters"
        >
          {{ t("confirm") }}
        </BaseButton>
      </div>
    </div>
  </BaseBoxColor>
</template>

<script setup>
import { ref, defineProps, defineEmits, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  filters: {
    type: Object,
    required: true
  },
  channelTypeOptions: {
    type: Array,
    default: () => ["mail", "chat", "telegram"]
  }
})

const emit = defineEmits(['update:filters', 'apply-filters'])

const sessionSearchRef = ref(null)
const messageSearchRef = ref(null)
const datePickerRef = ref(null)

const updateFilters = (key, value) => {
  const newFilters = { ...props.filters, [key]: value }
  emit('update:filters', newFilters)
}

const handleApplyFilters = () => {
  emit('apply-filters')
}

const setSessionSearch = (value) => {
  sessionSearchRef.value?.set(value)
}

const setMessageSearch = (value) => {
  messageSearchRef.value?.set(value)
}

const setDatePicker = (value) => {
  datePickerRef.value?.set(value)
}

defineExpose({
  setSessionSearch,
  setMessageSearch,
  setDatePicker
})
</script>